import { Component, ChangeDetectionStrategy, OnInit, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BreadcrumbItem, SeoComponent } from '@shared/components';
import { RoutingTabTitleService } from '@shared/service/routing-tab-title/routing-tab-title.service';
import { BehaviorSubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { BreadcrumbComponent } from '../../../shared/components/breadcrumb/breadcrumb.component';
import { ProductsCategoriesComponent } from '../../components/products-categories/products-categories.component';
import { ProductsListingComponent } from '../../components/products-listing/products-listing.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BreadcrumbComponent, ProductsCategoriesComponent, ProductsListingComponent, AsyncPipe],
})
export class ProductsComponent extends SeoComponent implements OnInit, OnDestroy {
    private routingTabTitleService = inject(RoutingTabTitleService);
    private activatedRoute = inject(ActivatedRoute);
    private translateService = inject(TranslateService);

    breadcrumbs: BreadcrumbItem[] = [
        {
            name: 'NAVIGATION.MAIN.main_page',
            url: '/',
        },
        {
            name: 'NAVIGATION.MAIN.products',
            url: null,
        },
    ];

    breadcrumbsSearch: BreadcrumbItem[] = [
        {
            name: 'NAVIGATION.MAIN.main_page',
            url: '/',
        },
        {
            name: 'NAVIGATION.MAIN.products',
            url: '/products',
        },
        {
            name: 'NAVIGATION.MAIN.search',
            url: null,
        },
    ];

    isSearch$ = new BehaviorSubject(false);

    override ngOnInit(): void {
        super.ngOnInit();

        this.subscriptions$.add(
            this.routingTabTitleService.currentPageTitle$
                .pipe(
                    tap((title) => {
                        this.seoTitle$.next(title);
                        this.seoDescription$.next(this.routingTabTitleService.translateTitle('SEO.PRODUCTS.description'));
                    }),
                )
                .subscribe(),
        );
        this.subscriptions$.add(
            this.activatedRoute.queryParams
                .pipe(
                    map((params) => (params['q'] ? params['q'] : '')),
                    tap((q) => {
                        if (q) {
                            this.isSearch$.next(true);
                            this.breadcrumbsSearch[2].name = this.translateService.instant('NAVIGATION.MAIN.search') + q;
                            this.breadcrumbsSearch = [...this.breadcrumbsSearch];
                        } else {
                            this.isSearch$.next(false);
                        }
                    }),
                )
                .subscribe(),
        );
    }
}
